import React, { useState, useEffect } from 'react';
import './timelinemain.css';
import axios from 'axios';
import { Newspaper } from 'lucide-react';

const config = require('../../config.json');

export default function TimelineVJ() {
  const [insights, setInsights] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetchActiveInfo();
  }, []);

  const generateDate = async () => {
    const d = new Date();
    const pad = (n) => n.toString().padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  const fetchActiveInfo = async () => {
    try {
      setLoaded(false);
      const startDate = await generateDate();
      const clientID = "VJCollege";
      const searchOption = "Top Story";
      
      const response = await axios.get(
        `${config.api.invokeURL}/dashboard/infodesk?clientID=${clientID}&startDate=${startDate}&searchOption=${searchOption}`,
        {
          headers: {
            'x-api-key': config.api.key
          }
        }
      );

      if (response.data && response.data.length > 0) {
        const result = response.data.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
        setInsights(result);
      }
    } catch (error) {
      console.error("Error fetching top stories:", error);
    } finally {
      setLoaded(true);
    }
  };

  return (
    <div className="w-100" style={{ maxHeight: '720px', overflowY: 'auto' }}>
      <div className="timelineCSS rounded-3">
        {loaded && insights.length > 0 ? (
          <ul>
            {insights.map((story, index) => (
              <li style={{ "--accent-color": story.topStory?.timelineColor || '#1a2b56' }} key={index}>
                <div className="date">{story.topStory?.timelineHeader}</div>
                <div className="title">{story.topStory?.timelineTitle}</div>
                {story.topStory?.timelineImage && (
                  <div className="title text-center p-2">
                    <img 
                      src={`${config.s3.ImageinvokeURL}images/topstories/${story.topStory.timelineImage}`} 
                      alt={story.topStory?.timelineTitle} 
                      className="img-fluid rounded-3"
                      style={{ maxHeight: '250px', objectFit: 'cover' }}
                    />
                  </div>
                )}
                <div className="descr">{story.topStory?.timelineDescription}</div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-center py-5 text-muted">
            <Newspaper size={36} className="opacity-40 mb-2" />
            <p className="small mb-0">No top stories available currently.</p>
          </div>
        )}
      </div>
    </div>
  );
}
